
export class GetDefaultParquetPartitionedIngestNodePathRequest {
    organizationId: number;

    constructor(organizationId: number) {
      this.organizationId = organizationId;
    }
}

